import { render } from "./SecondSidebar.vue?vue&type=template&id=02dac064&scoped=true"
import script from "./SecondSidebar.vue?vue&type=script&lang=js"
export * from "./SecondSidebar.vue?vue&type=script&lang=js"

import "./SecondSidebar.vue?vue&type=style&index=0&id=02dac064&lang=css"
import "./SecondSidebar.vue?vue&type=style&index=1&id=02dac064&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02dac064"]])

export default __exports__